<div class="hypertracktrip">
  <div class="hypertracktrip__header row">
    <h6 class="col-6">Trip ID : {{ trip.tripId }}</h6>
    <span class="hypertracktrip__header__close col-6"
      ><i
        class="menu-item-icon fa fa-window-close-o"
        (click)="dialogClose()"
      ></i
    ></span>
  </div>
  <div class="hypertracktrip__details">
    <iframe
      class="hypertracktrip__iframe"
      [src]="iframeSrc"
      frameborder="0"
      allowfullscreen
    >
    </iframe>
  </div>
</div>
